import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

const CustomDatePicker = ({ outputFormat, controlled = true, ...props }) => {
  if (controlled)
    return (
      <DatePicker
        format={props.format || "DD/MM/YYYY"}
        {...props}
        onChange={(value) => (value && value !== "Invalid Date" ? props.onChange(dayjs(value).format(outputFormat || "YYYY-MM-DD")) : props.onChange(""))}
        value={props.value ? dayjs(props.value) : null}
        slotProps={{
          textField: {
            focused: true,
          },
        }}
      />
    );
  return (
    <DatePicker
      defaultValue={props.defaultValue ? dayjs(props.defaultValue) : null}
      format={props.format || "DD/MM/YYYY"}
      {...props}
      onChange={(value) => (value && value !== "Invalid Date" ? props.onChange(dayjs(value).format(outputFormat || "YYYY-MM-DD")) : props.onChange(""))}
    />
  );
};
export default CustomDatePicker;
